import styled from 'styled-components'

const ReportSummaryPercentIndicator = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: -3px;
`

export default ReportSummaryPercentIndicator